const translations = {
    loading: 'Loading',
    noMoreResults: 'No more results'
};

export default translations;
